<div class="root-container">
	<div class="signin-box">
		<ng-container *ngIf="!redirectionIsChecked; else redirectionChecked">
			<div class="redirect-spinner-container">
				<div class="loading-spinner-white"></div>
			</div>
		</ng-container>
		<ng-template #redirectionChecked>
			<div class="signin-informations">
				<div class="signin-header">
					<div class="logo">
						<i class="icon-smash_icologo_chip"></i>
					</div>
					<h1 translate>SIGNIN_CONNECT_TITLE</h1>
				</div>
				<form [formGroup]="signinForm" class="signin-form" (ngSubmit)="onSubmit()">
					<!-- Email template -->
					<ng-container *ngTemplateOutlet="email; context: {form: signinForm}"></ng-container>
					<!-- Password template -->
					<ng-container *ngTemplateOutlet="password; context: {form: signinForm}"></ng-container>
				</form>
			</div>
		</ng-template>
	</div>
</div>

<!-- Email form template-->
<ng-template #email let-form="form">
	<div class="email-form" [ngClass]="{'visible': signinStep !== 'password'}">
		<div [formGroup]="form" class="input-container">
			<app-smash-input type="email" placeholder="{{ 'SIGNIN_USERNAME' | translate }}" formControlName="username" autocomplete="email"
				[error]="submittedEmail && f.username.errors" [processing]="(configurationLoading$ | async)">
				<div *ngIf="!!(configurationError$ | async)" error>{{ ( configurationError$ | async | translate) }}</div>
				<div *ngIf="submittedEmail && f?.username?.errors" error>{{ 'SIGNIN_ALERT_MESSAGE_INCORRECT_EMAIL' | translate }}</div>
			</app-smash-input>
		</div>
		<div class="signin-form-footer">
			<button class="btn white" type="button" [routerLink]="['']"
				[disabled]="(configurationLoading$ | async)">{{'SIGNIN_BUTTON_LABEL_CANCEL' | translate}}</button>
			<button class="btn red" type="submit" [disabled]="(configurationLoading$ | async)">
				<ng-container *ngIf="!(configurationLoading$ | async); else configurationLoading">
					{{'SIGNIN_BUTTON_LABEL_NEXT' | translate}}
				</ng-container>
				<ng-template #configurationLoading>
					<div class="spinner-container">
						<div class="loading-spinner-white"></div>
					</div>
				</ng-template>
			</button>
		</div>
	</div>
</ng-template>

<!-- Password form template-->
<ng-template #password let-form="form">
	<div class="password-form" [ngClass]="{'visible': signinStep === 'password'}">
		<div *ngIf="!!(signinWithPasswordError$ | async) && (signinWithPasswordError$ | async)==='SIGNIN_ALERT_MESSAGE_INVALID_ACCOUNT'"
			class="signin-form-invalid-account"
			error
			translate
			[innerHtml]="(signinWithPasswordError$ | async | translate | safeHtml)"></div>

		<div *ngIf="(signinWithPasswordError$ | async) !=='SIGNIN_ALERT_MESSAGE_INVALID_ACCOUNT'" [formGroup]="form" class="input-container">
			<app-smash-input type="password" placeholder="{{ 'SIGNIN_PASSWORD' | translate }}" formControlName="password"  autocomplete="on"
				[error]="submittedPassword && f.password.errors" [processing]="(signinWithPasswordLoading$ | async)">				
				<div *ngIf="!!(signinWithPasswordError$ | async)" error translate [innerHtml]="(signinWithPasswordError$ | async | translate | safeHtml)"></div>
				<div *ngIf="submittedPassword && f?.password?.errors && !(signinWithPasswordError$ | async)" error>{{ 'SIGNIN_ALERT_MESSAGE_INVALID_PASSWORD' | translate }}</div>
			</app-smash-input>
			<div class="forgot-password-container">
				<a class="forgot-password-link" [class.disabled]="(signinWithPasswordLoading$ | async) ? true : null"
					[routerLink]="['forgot/password']" translate>SIGNIN_LINK_LABEL_FORGOTTEN_PASSWORD</a>
			</div>
		</div>
		<div class="signin-form-footer ">
			<button *ngIf="(signinWithPasswordError$ | async)!=='SIGNIN_ALERT_MESSAGE_INVALID_ACCOUNT'" class="btn white" type="button" (click)="backToEmail()" [disabled]="(signinWithPasswordLoading$ | async)"
				translate>SIGNIN_BUTTON_LABEL_CANCEL</button>
			<button *ngIf="!!(signinWithPasswordError$ | async) && (signinWithPasswordError$ | async)==='SIGNIN_ALERT_MESSAGE_INVALID_ACCOUNT'" class="btn white" type="button" (click)="backToEmail()" [disabled]="(signinWithPasswordLoading$ | async)"
				translate>BACK</button>
			<button *ngIf="(signinWithPasswordError$ | async) !=='SIGNIN_ALERT_MESSAGE_INVALID_ACCOUNT'" class="btn red" type="submit" [disabled]="(signinWithPasswordLoading$ | async)">
				<ng-container *ngIf="!(signinWithPasswordLoading$ | async); else signinWithPasswordLoading">
					{{'SIGNIN_BUTTON_LABEL_CONNECT' | translate}}
				</ng-container>
				<ng-template #signinWithPasswordLoading>
					<div class="spinner-container">
						<div class="loading-spinner-white"></div>
					</div>
				</ng-template>
			</button>
		</div>
	</div>
</ng-template>

<app-cgu-cookie-container template="MAIN"></app-cgu-cookie-container>